import css from '../../../utils/css';

export default css`
  #rootElement > div {
    --mix-of-cta-colors: color-mix(
      in lch,
      var(--widget-cta-background-color) 90%,
      var(--widget-cta-color)
    );

    --font-family: var(--widget-font-family);
    --offer-cta-color: var(--widget-cta-color);
    --offer-cta-bg-color: var(--widget-cta-background-color);
    --offer-cta-bg-color-hover: var(--mix-of-cta-colors);
  }
`;
